//@flow
//@flow
import { Formik } from 'formik';
import _ from 'lodash';
import 'moment/locale/pt-br';
import * as React from 'react';
import 'react-confirm-alert/src/react-confirm-alert.css';
import connect from 'react-redux/es/connect/connect';
import * as Yup from 'yup';
import { FormGroup } from '../../../components/FormGroup';
import FormInput from '../../../components/inputs/FormInput';
import FormSelectInput from '../../../components/inputs/FormSelectInput';
import InputViewEdit from '../../../components/inputs/InputViewEdit';
import SelectInput from '../../../components/inputs/SelectInput';
import MultiTelefones from '../../../components/MultiTelefones/MultiTelefones';
import { translate } from '../../../_helpers/messages.helper';
import { defaultService } from '../../../_services/defaultService';
import { estabelecimentoService } from '../../../_services/estabelecimento.service';
import { estocagemService } from '../../../_services/estocagem.service';
import { unidadePadraoService } from '../../../_services/unidadePadrao.service';
import { perfilservice } from '../../../_services/perfil.service';
import UnidadeFracao from './unidadeFracao/UnidadeFracao';
import MoneyInput from '../../../components/inputs/MoneyInput';
import { formatterHelper } from '../../../_helpers/formatter.helper';

type Props = {
  match: any,
  nome?: string,
  callbackOnSave?: any,
};

type State = {
  id?: number,
};
const OBRIGATORIO = 'Obrigatório';
const STRING_REQUIRED = Yup.string().required(OBRIGATORIO);
const EstoqueProdutosunidadePadraoValidate = Yup.object().shape({
  estocagem: Yup.object().shape({
    unidadePadrao: STRING_REQUIRED,
    localizacao: STRING_REQUIRED,
    custo: STRING_REQUIRED,
    precoVendaParticular: STRING_REQUIRED,
    precoVendaConvenio: STRING_REQUIRED,
    estoqueMinimo: STRING_REQUIRED,
    estoqueMaximo: STRING_REQUIRED,
    estoqueInicial: STRING_REQUIRED,
    listUnidadeFracao: Yup.array().of(
      Yup.object().shape({
        quantidade: STRING_REQUIRED,
        unidadePadrao: STRING_REQUIRED,
        precoVendaParticular: STRING_REQUIRED,
        precoVendaConvenio: STRING_REQUIRED,
      })
    ),
  }),
});

class EstoqueProdutosUnidadePadraoForm extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
  }

  goToViewEntity = (values) => {
    const { redirectPath } = this.props;
    this.props.history.push({
      pathname: redirectPath + values.id,
      state: { entity: values },
    });
  };

  addUnidadeFracao = (
    propName,
    defaultValue,
    values,
    setValues,
    createAttribute?: boolean
  ) => {
    let newValues = _.cloneDeep(values);
    if (newValues.estocagem[propName]) {
      newValues.estocagem[propName].unshift(
        defaultValue ? defaultValue : { idList: new Date().getTime() }
      );
      setValues(newValues);
    }
    if (!newValues.estocagem[propName] && createAttribute) {
      _.set(newValues.estocagem, `${propName}`, [
        { idList: new Date().getTime() },
      ]);
      setValues(newValues);
    }
  };

  removeUnidadeFracao = (propName, indexItem, values, setValues) => {
    let newValues = _.cloneDeep(values);
    if (newValues.estocagem[propName].length >= 1) {
      newValues.estocagem[propName].splice(indexItem, 1);
      setValues(newValues);
    }
  };
  saveForm = () => {
    let _this = this;
    let values = _this.formRef.state.values;
    let promise = new Promise(function (resolve) {
      _this.formRef.validateForm(values).then((error) => {
        if (_.isEmpty(error)) {
          _this.props.loading(true);
          _.set(values.estocagem, 'estoque', { id: values.id });
          estocagemService.doSave(values.estocagem).then(
            (response) => {
              _this.props.success({
                message: `Estocagem, foi ${
                  !values.id ? 'criada' : 'alterada'
                } com sucesso!`,
              });
              _this.props.loading(false);
              resolve(true);
            },
            (erros) => {
              _this.props.loading(false);
              _this.props.error({
                message: 'Não foi possível salvar Estocagem.',
              });
              try {
                let response = erros.response.data;
                if (response && response.messages) {
                  for (var i = 0; i < response.messages.length; i++) {
                    let erroItem = response.messages[i];
                    _this.formRef.setFieldError(
                      erroItem.fieldName,
                      translate(erroItem.message.code)
                    );
                  }
                }
              } catch (error) {
                console.log(error);
              }
              console.log(erros);
            }
          );
        } else {
          resolve(false);
        }
      });
    });
    return promise;
  };

  resetForm = (initialValues) => {
    this.formRef.resetForm(initialValues);
  };
  render() {
    let _this = this;
    const { viewMode, entity, propName, index } = this.props;
    return (
      <React.Fragment>
        <Formik
          validationSchema={EstoqueProdutosunidadePadraoValidate}
          validateOnBlur={false}
          validateOnChange={false}
          enableReinitialize={true}
          initialValues={entity}
          ref={(form) => {
            this.formRef = form;
          }}
        >
          {({
            values,
            errors,
            touched,
            handleChange,
            handleSubmit,
            isSubmitting,
            setFieldValue,
            validationSchema,
            validateForm,
            setValues,
          }) => (
            <form onSubmit={handleSubmit}>
              {console.log(errors)}
              <div className="form-inside">
                <div className="row section-form">
                  <FormGroup className="col-12 col-xl-2">
                    <InputViewEdit
                      viewClassName="font-weight-bold"
                      name="estocagem.unidadePadrao"
                      label="Unidade padrão"
                      placeholder="Selecione a unidade padrão"
                      component={FormSelectInput}
                      service={unidadePadraoService.findByEstabelecimento}
                      labelKey={'nome'}
                      valueKey={'id'}
                      returnFullObject={true}
                      defaultValue={_.get(
                        values,
                        'estocagem.unidadePadrao.nome',
                        '--'
                      )}
                      required={true}
                      value={_.get(values, 'estocagem.unidadePadrao')}
                      viewMode={viewMode}
                      id="unidadePadrao"
                      name="estocagem.unidadePadrao"
                      onChange={(name, value) => {
                        if (!value.id) {
                          unidadePadraoService
                            .doSave(value)
                            .then((response) => {
                              let id = defaultService.getIdFromUrl(
                                response.headers.location
                              );
                              _.set(value, 'id', id);
                              setFieldValue(name, value);
                            });
                        } else {
                          setFieldValue(name, value);
                        }
                      }}
                      erroMensagem={_.get(errors, 'estocagem.unidadePadrao')}
                      sortNoAsc={true}
                      sortKey={'nome'}
                      creatable={true}
                    />
                  </FormGroup>
                  <FormGroup className="col-12 col-xl-2">
                    <InputViewEdit
                      component={FormInput}
                      label={'Localização'}
                      type="text"
                      id="localizacao"
                      name="estocagem.localizacao"
                      placeholder="Informe o código da localização"
                      value={_.get(values, 'estocagem.localizacao')}
                      onChange={(name, value) => setFieldValue(name, value)}
                      noSize={true}
                      erroMensagem={_.get(errors, 'estocagem.localizacao')}
                      viewMode={viewMode}
                      required={true}
                    />
                  </FormGroup>
                  <FormGroup className="col-12 col-xl-2">
                    <InputViewEdit
                      component={MoneyInput}
                      label={'Custo'}
                      type="number"
                      id="custo"
                      name="estocagem.custo"
                      placeholder="Informe o custo"
                      value={_.get(values, 'estocagem.custo')}
                      onChange={(name, value) => setFieldValue(name, value)}
                      defaultValue={formatterHelper.money(
                        _.get(values, 'estocagem.custo')
                      )}
                      noSize={true}
                      erroMensagem={_.get(errors, 'estocagem.custo')}
                      viewMode={viewMode}
                      required={true}
                    />
                  </FormGroup>
                  <FormGroup className="col-12 col-xl-2">
                    <InputViewEdit
                      component={MoneyInput}
                      label={'Preço venda particular'}
                      type="number"
                      id="precoVendaParticular"
                      name="estocagem.precoVendaParticular"
                      placeholder="Informe o preço de venda particular"
                      value={_.get(values, 'estocagem.precoVendaParticular')}
                      onChange={(name, value) => setFieldValue(name, value)}
                      defaultValue={formatterHelper.money(
                        _.get(values, 'estocagem.precoVendaParticular')
                      )}
                      noSize={true}
                      erroMensagem={_.get(
                        errors,
                        'estocagem.precoVendaParticular'
                      )}
                      viewMode={viewMode}
                      required={true}
                    />
                  </FormGroup>
                  <FormGroup className="col-12 col-xl-2">
                    <InputViewEdit
                      component={MoneyInput}
                      label={'Preço venda convênio'}
                      type="number"
                      id="precoVendaConvenio"
                      name="estocagem.precoVendaConvenio"
                      placeholder="Informe o preço de venda convênio"
                      value={_.get(values, 'estocagem.precoVendaConvenio')}
                      onChange={(name, value) => setFieldValue(name, value)}
                      defaultValue={formatterHelper.money(
                        _.get(values, 'estocagem.precoVendaConvenio')
                      )}
                      noSize={true}
                      erroMensagem={_.get(
                        errors,
                        'estocagem.precoVendaConvenio'
                      )}
                      viewMode={viewMode}
                      required={true}
                    />
                  </FormGroup>
                  <FormGroup className="col-12 col-xl-3">
                    <InputViewEdit
                      component={FormInput}
                      label={'Estoque mínimo'}
                      type="number"
                      id="estoqueMinimo"
                      name="estocagem.estoqueMinimo"
                      placeholder="Informe o estoque mínimo"
                      value={_.get(values, 'estocagem.estoqueMinimo')}
                      onChange={(name, value) => setFieldValue(name, value)}
                      noSize={true}
                      erroMensagem={_.get(errors, 'estocagem.estoqueMinimo')}
                      viewMode={viewMode}
                      required={true}
                    />
                  </FormGroup>
                  <FormGroup className="col-12 col-xl-3">
                    <InputViewEdit
                      component={FormInput}
                      label={'Estoque máximo'}
                      type="number"
                      id="estoqueMaximo"
                      name="estocagem.estoqueMaximo"
                      placeholder="Informe o estoque máximo"
                      value={_.get(values, 'estocagem.estoqueMaximo')}
                      onChange={(name, value) => setFieldValue(name, value)}
                      noSize={true}
                      erroMensagem={_.get(errors, 'estocagem.estoqueMaximo')}
                      viewMode={viewMode}
                      required={true}
                    />
                  </FormGroup>
                  <FormGroup className="col-12 col-xl-3">
                    <InputViewEdit
                      component={FormInput}
                      label={'Estoque inicial'}
                      type="number"
                      id="estoqueInicial"
                      name="estocagem.estoqueInicial"
                      placeholder="Informe o estoque máximo"
                      value={_.get(values, 'estocagem.estoqueInicial')}
                      onChange={(name, value) => setFieldValue(name, value)}
                      noSize={true}
                      erroMensagem={_.get(errors, 'estocagem.estoqueInicial')}
                      viewMode={viewMode}
                      required={true}
                    />
                  </FormGroup>
                </div>
                {_.get(values, 'estocagem.listUnidadeFracao') &&
                  _.get(values, 'estocagem.listUnidadeFracao').length > 0 && (
                    <h1 className="w-100">Unidades fração</h1>
                  )}

                <div
                  className={`form-row justify-content-md-start justify-content-center pl-10px ${
                    viewMode ? 'd-none' : ''
                  }`}
                >
                  <button
                    onClick={() =>
                      this.addUnidadeFracao(
                        'listUnidadeFracao',
                        null,
                        values,
                        setValues,
                        true
                      )
                    }
                    type="button"
                    className="btn btn-primary"
                  >
                    Adicionar unidade fração
                  </button>
                </div>

                {_.get(values, 'estocagem.listUnidadeFracao') &&
                  !_.isEmpty(_.get(values, 'estocagem.listUnidadeFracao')) &&
                  _.get(values, 'estocagem.listUnidadeFracao').length > 0 &&
                  _.get(values, 'estocagem.listUnidadeFracao').map(
                    (unidadeFracao, index) => {
                      return (
                        <div className="row section-form" key={index}>
                          <UnidadeFracao
                            entity={values}
                            index={index}
                            viewMode={viewMode}
                            size={
                              _.get(values, 'estocagem.listUnidadeFracao')
                                .length
                            }
                            handleChange={handleChange}
                            errors={errors}
                            propName={`estocagem.listUnidadeFracao[${index}]`}
                            onChange={setFieldValue}
                            removeItem={() => {
                              this.removeUnidadeFracao(
                                `listUnidadeFracao`,
                                index,
                                values,
                                setValues
                              );
                            }}
                          ></UnidadeFracao>
                        </div>
                      );
                    }
                  )}
              </div>
            </form>
          )}
        </Formik>
      </React.Fragment>
    );
  }
}

function mapStateToProps(state) {
  const { user } = state.authentication;
  return {
    user,
  };
}

const mapDispatch = ({
  alert: { success, error, clear },
  load: { loading },
  authentication: { refreshUser },
}) => ({
  refreshUser: (user) => refreshUser({ user }),

  success: (msg) => success(msg),
  loading: (load: boolean) => loading({ load }),
  error: (msg) => error(msg),
  clear: () => clear(),
});

export default connect(mapStateToProps, mapDispatch, null, {
  forwardRef: true,
})(EstoqueProdutosUnidadePadraoForm);
